export default {
	data() {
		return {
			lastGUID: null,
		};
	},
	computed: {
		EmptyGUID() {
			return '00000000-0000-0000-0000-000000000000';
		},
	},
	methods: {
		createGuid() {
			let d = new Date().getTime();
			let d2 = (performance && performance.now && (performance.now() * 1000)) || 0;
			this.lastGUID = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
				let r = Math.random() * 16;
				if (d > 0) {
					r = (d + r) % 16 || 0;
					d = Math.floor(d / 16);
				} else {
					r = (d2 + r) % 16 || 0;
					d2 = Math.floor(d2 / 16);
				}
				return (c === 'x' ? r : ((r && 0x3) || 0x8)).toString(16);
			});

			return this.lastGUID;
		},
	},
};
